import { observable } from 'mobx';
import type { DTO } from '@/type-utils';
import { ISearchTermsSuggestion } from './ISearchTermsSuggestion';
import Model from '../Model';
import type { ISearchSuggestions } from './ISearchSuggestions';
import type { IProduct } from '../Product';
import type { ISearchMetadata } from './ISearchMetadata';

/**
 * A model with search suggestions based on a term.
 */
export default class SearchSuggestionsModel
  extends Model<DTO<ISearchSuggestions>>
  implements ISearchSuggestions
{
  @observable
  private _productSuggestions: ReadonlyArray<DTO<IProduct>>;

  @observable
  private _searchTermsSuggestions: ReadonlyArray<ISearchTermsSuggestion>;

  @observable
  private _metadata: ISearchMetadata;

  /** @inheritdoc */
  public get productSuggestions(): ReadonlyArray<DTO<IProduct>> {
    return this._productSuggestions;
  }

  /** @inheritdoc */
  public get searchTermsSuggestions(): ReadonlyArray<ISearchTermsSuggestion> {
    return this._searchTermsSuggestions;
  }

  /** @inheritdoc */
  public get metadata(): ISearchMetadata {
    return this._metadata;
  }

  /**
   * The constructor from the SearchSuggestionsModel.
   *
   * @param dto - A DTO which represents this model.
   */
  public constructor(dto: ISearchSuggestions) {
    super(dto);
    this._productSuggestions = dto.productSuggestions;
    this._searchTermsSuggestions = dto.searchTermsSuggestions;
    this._metadata = dto.metadata;
  }

  /** @inheritdoc */
  public override toDTO(): DTO<ISearchSuggestions> {
    return {
      productSuggestions: this.productSuggestions,
      searchTermsSuggestions: this.searchTermsSuggestions,
      metadata: this.metadata
    } as DTO<ISearchSuggestions>;
  }
}
